(() => {
  const bind = () => {
    const count = document.querySelector('[data-sa-cart-count]');
    if (!count || count.dataset.bound) return;
    count.dataset.bound = 'true';
    let revision = 0;
    subscribe(PUB_SUB_EVENTS.cartUpdate, async event => {
      const current = ++revision;
      try {
        const cart = typeof event.cartData?.item_count === 'number' ? event.cartData : await fetch(`${window.routes.cart_url}.js`, {headers:{Accept:'application/json'}}).then(response => response.json());
        if (current !== revision) return;
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      } catch (error) { console.error('Could not refresh cart count', error); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();
